import React, {
  HTMLAttributes,
  LazyExoticComponent,
  Suspense,
  useMemo,
} from 'react';

import { icons } from './icons';
import { classNames } from 'primereact/utils';

export type AXIconName = keyof typeof icons;
export type AXIconSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
interface Props extends HTMLAttributes<HTMLDivElement> {
  icon: AXIconName;
  className?: string;
  // These props make styling component easier than creating new classes
  rotate?: number;
  size?: AXIconSizes;
}
interface AXIconSize {
  [key: string]: string;
}
const sizes: AXIconSize[] = [
  { xs: '.65rem' },
  { sm: '.875rem' },
  { md: '1.25rem' },
  { lg: '1.75rem' },
  { xl: '2.5rem' },
];
/**
 *
 * @param icon string key icon name
 * @param className string classes for styling
 * @param rotate optional number rotation of the icon
 * @param color
 * @param size
 * @param rest
 * @returns Icon react component
 */
export const AXIcon = ({
  icon,
  className,
  rotate,
  size = 'md',
  ...rest
}: Props) => {
  const SvgIcon: LazyExoticComponent<React.FC<any>> = useMemo(
    () => icons[icon],
    [icon],
  );

  if (!SvgIcon) return null;
  const iconSize = sizes.find((s) => s[size]);

  return (
    <Suspense fallback={null}>
      <SvgIcon
        className={classNames('shrink-0', className)}
        aria-label={icon}
        role="img"
        style={{
          display: 'block',
          verticalAlign: '-0.075em',
          transform: rotate ? `rotate(${rotate}deg)` : undefined,
          width: !iconSize || iconSize[size] || '1.25rem',
          height: !iconSize || iconSize[size] || '1.25rem',
          overflow: 'inherit',
        }}
        {...rest}
      />
    </Suspense>
  );
};
